import { render, staticRenderFns } from "./OrderBillDetail.vue?vue&type=template&id=1afe2eb4&scoped=true"
import script from "./OrderBillDetail.vue?vue&type=script&lang=js"
export * from "./OrderBillDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderBillDetail.vue?vue&type=style&index=0&id=1afe2eb4&prod&scoped=true&lang=css"
import style1 from "./OrderBillDetail.vue?vue&type=style&index=1&id=1afe2eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afe2eb4",
  null
  
)

export default component.exports